import React, { useState } from 'react';
import { Menu, X, Mic2 } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Voices',
    href: '#voices'
  }, {
    name: 'Features',
    href: '#features'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Studio',
    href: '#studio'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0F]/90 backdrop-blur-md border-b border-white/10" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="flex items-center justify-between h-16" data-id="element-97">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2" data-id="element-98">
            <div className="w-8 h-8 bg-[#00F0FF] rounded flex items-center justify-center text-black" data-id="element-99">
              <Mic2 size={20} data-id="element-100" />
            </div>
            <span className="text-xl font-bold font-mono tracking-tighter text-white" data-id="element-101">
              ECHEC<span className="text-[#00F0FF]" data-id="element-102">GAMER</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:block" data-id="element-103">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-104">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-300 hover:text-[#00F0FF] px-3 py-2 rounded-md text-sm font-medium font-mono transition-colors" data-id="element-105">
                  {link.name}
                </a>)}
            </div>
          </div>

          {/* CTA */}
          <div className="hidden md:block" data-id="element-106">
            <Button size="sm" data-id="element-107">Start Creating</Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-108">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-white/10 focus:outline-none" data-id="element-109">
              {isOpen ? <X size={24} data-id="element-110" /> : <Menu size={24} data-id="element-111" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-[#0A0A0F] border-b border-white/10" data-id="element-112">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-113">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-300 hover:text-[#00F0FF] block px-3 py-2 rounded-md text-base font-medium font-mono" onClick={() => setIsOpen(false)} data-id="element-114">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-115">
              <Button className="w-full" data-id="element-116">Start Creating</Button>
            </div>
          </div>
        </div>}
    </nav>;
}